"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.ImageSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _utils = require("../CategoryBox/utils");
var _styles = require("../styles");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  width
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  maxWidth: width.mobile,
  [theme.breakpoints.up('sm')]: {
    maxWidth: width.desktop
  }
}));
const ImageSkeleton = exports.ImageSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['size'])
})(({
  theme,
  size
}) => {
  const height = (0, _utils.getCategoryBoxImageHeight)({
    size
  });
  return {
    width: '100%',
    borderRadius: theme.spacing(2),
    height: height.mobile,
    [theme.breakpoints.up('sm')]: {
      height: height.desktop
    }
  };
});
//# sourceMappingURL=styles.js.map